import { StopNotesAndReferenceNumbers } from "../../../dispatch/src/StopNotesAndReferenceNumbers";
import { StopShowAsButton } from "../../../dispatch/src/StopShowAsButton";
import { DataSource, Label, Layout, Location, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutQuoteStop extends Layout {
    labelDelivery: Label;
    labelPickup: Label;
    labelSequence: Label;
    layoutStopNotesAndRefNbrs: StopNotesAndReferenceNumbers;
    layoutStopShowAsButton: StopShowAsButton;
    locationStop: Location;
    panelContainer: Panel;
    panelContent: Panel;
    panelPickupDelivery: Panel;
    panelStopCommentsReferenceNumbers: Panel;
    sourceQuoteStop: DataSource;
    switchPickupConsignee: Switch;
    textboxSchedArriveEarly: Textbox;
}
